import styled from "styled-components"

const Form = styled.div`
	padding: 1em 2em;
	overflow-x: hidden;
	overflow-y: auto;
`

export default Form
